/**
 * Converts a mileage distance from its stored hundredths representation
 * to a human-readable decimal number.
 * The backend stores mileage distances as integers in hundredths of km/mi
 * (e.g. 3000 → 30, 1050 → 10.5).
 */
export const formatStoredMileage = (value: number): number => {
  return value / 100
}

export const convertToNumber = (value: string | number | undefined | null): number => {
  if (!value) return 0.0
  if (typeof value === 'number') return value

  const sanitizedValue = value.replace(',', '.')
  const parsedValue = parseFloat(sanitizedValue)
  return isNaN(parsedValue) ? 0.0 : parsedValue
}
